import React, { useState } from 'react';
import { DillButton, DillModal } from '../../../general/Dill';
import { isHTML, openDillToast } from '../../../../utils/helpers';
import { useWindowActualWidth } from '../../../../utils/domTools';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { twMerge } from 'tailwind-merge';
import { createCreditApplicationMonitor } from '../../../../redux/services/creditApplicationsMonitorService';

const NACMCreditReportModal = ({
  open,
  handleClose,
  details,
  nacmId,
  creditApplicationId,
}: {
  open: boolean;
  handleClose: () => void;
  details: string;
  nacmId: string;
  creditApplicationId: string;
}) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  const [loading, setLoading] = useState(false);

  const width = useWindowActualWidth();
  const handleCloseModal = () => {
    setLoading(false);
    handleClose();
  };

  const disableHtmlInteractions = (html: string) => {
    const overlay = '<div style="position:fixed;inset:0;z-index:2147483647;"></div>';
    if (/<\/body>/i.test(html)) {
      return html.replace(/<\/body>/i, `${overlay}</body>`);
    }
    return `${html}${overlay}`;
  };

  const handleCreateCreditMonitoring = async () => {
    setLoading(true);
    const response = await dispatch(
      createCreditApplicationMonitor({
        companyNACMID: nacmId,
        creditApplicationId,
        supplierId: currentSupplier?.id ?? '',
      })
    );
    if (response.type.includes('/fulfilled')) {
      openDillToast({
        type: 'SUCCESS',
        message: 'Report has been successfully saved.',
      });
      setLoading(false);
      handleCloseModal();
    } else {
      openDillToast({
        type: 'ERROR',
        message: 'Failed to save credit report.',
      });
      setLoading(false);
    }
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Credit Report"
      maxWidth="66vw"
      footer={
        <div className="flex justify-end w-full gap-2">
          <DillButton
            label="Close"
            variant="secondary"
            onClick={handleCloseModal}
            isDisabled={loading}
          />
          {/* Monitoring is tied to a credit application — not offered for internal forms. */}
          {currentSupplier?.creditReportSettings?.allowCreditReportMinitoring &&
            !!creditApplicationId && (
              <DillButton
                label="Save For Monitoring"
                onClick={handleCreateCreditMonitoring}
                isDisabled={loading}
                isLoading={loading}
              />
            )}
        </div>
      }>
      <div className={twMerge('flex flex-col', width > 1440 ? 'items-center' : '')}>
        {isHTML(details) ? (
          <iframe
            srcDoc={disableHtmlInteractions(details)}
            style={{ width: '100%', height: '80vh', border: 'none' }}
            sandbox="allow-scripts allow-same-origin"
            title="NACM Credit Report"
          />
        ) : (
          <p>{JSON.stringify(details)}</p>
        )}
      </div>
    </DillModal>
  );
};

export default NACMCreditReportModal;
